import React, {useState} from 'react';
import {useHistory} from 'react-router-dom';
import makeStyles from '@mui/styles/makeStyles';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import Avatar from '@mui/material/Avatar';
import Fab from '@mui/material/Fab';
import {
  Add,
  CalendarToday,
  CalendarTodayOutlined,
  DateRange,
  DateRangeOutlined,
  Folder,
  FolderOutlined,
  Pageview,
  PageviewOutlined,
} from '@mui/icons-material';
import {getProfileImage} from '../../../../util/UserUtils';
import DirectQuoteDialog from '../../components/DirectQuoteDialog';
import {NavigationPath} from '../SelectedIndexUtil';
import {theme} from '../../../../Theme';
import BidmiiTooltip from '../../../../common/StyledComponents/BidmiiTooltip';
import {useRecoilValue} from 'recoil';
import {userState} from '../../../../recoil/user/userAtom';

const useStyles = makeStyles((theme) => ({
  appBar: {
    top: 'auto',
    bottom: 0,
  },
  iconButton: {
    paddingBottom: 0,
  },
  icon: {
    width: window.outerWidth > 350 ? 24 : 20,
  },
  text: {
    fontSize: window.outerWidth > 350 ? 12 : 10,
  },
  menuItem: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    marginBottom: 6,
  },
  avatar: {
    paddingBottom: 0,
    width: 28,
    height: 28,
    alignSelf: 'center',
    '& img': {
      borderRadius: 30,
      border: `1px solid ${theme.palette.secondary.main}`,
    },
    '& :hover': {
      border: `1px ridge ${theme.palette.primary.main}`,
    },
    '& .MuiAvatar-fallback': {
      width: '100%',
      height: '100%',
      borderRadius: 30,
      padding: '6px',
      cursor: 'pointer',
    },
  },
}));

interface IProps {
  user: any;
  selectedIndex: NavigationPath;
}

export const MobileFooterContractor: React.FC<IProps> = (props) => {
  const history = useHistory();
  const user = useRecoilValue(userState);
  const classes = useStyles();

  const [DirectQuoteDialogOpen, setDirectQuoteDialogOpen] = useState(false);

  const toggleDirectQuoteDialog = () => {
    setDirectQuoteDialogOpen(!DirectQuoteDialogOpen);
  };

  const handleNavigate = (path: string) => {
    history.push(path);
  };

  return (
    <AppBar position="fixed" color={'secondary'} className={classes.appBar}>
      <Toolbar>
        <Grid container justifyContent="space-around" alignItems="flex-end">
          <Grid
            item
            className={classes.menuItem}
            onClick={() => history.push('/rfps')}>
            <IconButton
              color="primary"
              className={classes.iconButton}
              size="large">
              {props.selectedIndex === '/rfps' ? (
                <Pageview className={classes.icon} />
              ) : (
                <PageviewOutlined className={classes.icon} />
              )}
            </IconButton>
            <Typography variant={'h6'} className={classes.text}>
              OPEN JOBS
            </Typography>
          </Grid>
          <Grid
            item
            className={classes.menuItem}
            onClick={() => history.push('/myAwardedRfps')}>
            <IconButton
              color="primary"
              className={classes.iconButton}
              size="large">
              {props.selectedIndex === '/myAwardedRfps' ? (
                <Folder className={classes.icon} />
              ) : (
                <FolderOutlined className={classes.icon} />
              )}
            </IconButton>
            <Typography variant={'h6'} className={classes.text}>
              MY JOBS
            </Typography>
          </Grid>
          <Grid
            item
            className={classes.menuItem}
            onClick={() => handleNavigate('/mysitevisits')}>
            <IconButton
              color="primary"
              className={classes.iconButton}
              size="large">
              {props.selectedIndex === '/mysitevisits' ? (
                <DateRange className={classes.icon} />
              ) : (
                <DateRangeOutlined className={classes.icon} />
              )}
            </IconButton>
            <Typography variant={'h6'} className={classes.text}>
              SITE VISITS
            </Typography>
          </Grid>
          <Grid
            item
            className={classes.menuItem}
            onClick={() => history.push('/myproposals')}>
            <IconButton
              color="primary"
              className={classes.iconButton}
              size="large">
              {props.selectedIndex === '/myproposals' ? (
                <CalendarToday className={classes.icon} />
              ) : (
                <CalendarTodayOutlined className={classes.icon} />
              )}
            </IconButton>
            <Typography variant={'h6'} className={classes.text}>
              QUOTES
            </Typography>
          </Grid>
          <Grid
            item
            className={classes.menuItem}
            onClick={() => handleNavigate(`/user/${props.user.id}`)}>
            <Avatar
              aria-label="userProfileAvatarMenu"
              className={classes.avatar}
              src={getProfileImage(props.user, '100x100')}
            />
            <Typography variant={'h6'} className={classes.text}>
              PROFILE
            </Typography>
          </Grid>
        </Grid>
      </Toolbar>

      {[
        NavigationPath.RFPS,
        NavigationPath.MY_AWARDED_RFPS,
        NavigationPath.MY_PROPOSALS,
      ].includes(props.selectedIndex) &&
        user &&
        user?.userType === 'BIDDER' && (
          <BidmiiTooltip title="Send a Direct Quote">
            <Fab
              className="bounce"
              onClick={() => {
                toggleDirectQuoteDialog();
              }}
              style={{
                background: theme.palette.blue.main,
                position: 'fixed',
                right: 22,
                bottom: 85,
              }}>
              <Add />
            </Fab>
          </BidmiiTooltip>
        )}

      <DirectQuoteDialog
        open={DirectQuoteDialogOpen}
        toggleDirectQuoteDialog={toggleDirectQuoteDialog}
      />
    </AppBar>
  );
};
